export default "/images/glba_compliance_logo__large.png";